import { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/StatsSection.css";

const STAT_NUMS = [
  { num: 50,  prefix: "",  suffix: "+" },
  { num: 10,  prefix: "",  suffix: ""  },
  { num: 310, prefix: "+", suffix: "%" },
  { num: 12,  prefix: "",  suffix: "M+"},
];

function CountUp({ to, prefix, suffix, started, duration }) {
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!started) return;
    let raf;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [started, to, duration]);

  return <>{prefix}{val}{suffix}</>;
}

export default function StatsSection() {
  const { t } = useTranslation("stats");
  const sectionRef = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) { setStarted(true); obs.disconnect(); }
      },
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const items = t("items", { returnObjects: true });

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="stats-container">
        <header className="stats-header">
          <span className="stats-eyebrow">{t("eyebrow")}</span>
          <h2 className="stats-title">{t("title")}</h2>
        </header>

        <div className="stats-grid">
          {items.map((s, i) => (
            <div
              key={i}
              className={`stats-card${started ? " stats-card--in" : ""}`}
              style={{ "--i": i }}
            >
              <span className="stats-value">
                <CountUp
                  to={STAT_NUMS[i].num}
                  prefix={STAT_NUMS[i].prefix}
                  suffix={STAT_NUMS[i].suffix}
                  started={started}
                  duration={1400 + i * 120}
                />
              </span>
              <span className="stats-label">{s.label}</span>
              <p className="stats-context">{s.context}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
